import { Button } from "primereact/button";
import { useNavigate } from "react-router";

import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils";

/**
 * SessionExpiredPage - Displayed when a lesson session has expired due to inactivity
 */
const SessionExpiredPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full gap-2 relative" data-testid="session-expired-page">
      <div className="flex-1 flex items-center justify-center">
        <div className={C("rounded-lg shadow-lg p-12 max-w-md text-center", T.bgElevation2)}>
          <div className="flex justify-center mb-6">
            <i className="pi pi-times-circle text-red-600 text-5xl" />
          </div>
          <h2 className={C("text-3xl font-bold mb-3")}>Session Expired</h2>
          <p className={C("mb-2", T.textSecondary)}>Your session has expired due to inactivity.</p>
          <p className={C("text-sm mb-8", T.textPrimaryDarker)}>
            To continue, you can restart the lesson or return to the dashboard.
          </p>
          <div className="flex flex-col gap-3">
            <Button
              label="Restart Lesson"
              icon="pi pi-refresh"
              data-testid="session-expired-restart-button"
              onClick={() => window.location.reload()}
              className="w-full"
            />
            <Button
              label="Return to Dashboard"
              icon="pi pi-home"
              severity="secondary"
              data-testid="session-expired-dashboard-button"
              onClick={() => navigate("/")}
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredPage;
